import React from 'react'
import ConnectButton from './ConnectButton'
import ProviderRowBase, {} from './ProviderRowBase'









const ProviderRow = (props) => {
  const {onConnectClick, submitting, ...other} = props

  const connectButton = React.createElement(ConnectButton, { onConnectClick: onConnectClick, submitting: submitting,} )

  return React.createElement(ProviderRowBase, { ...other, connectButton: connectButton,} )
}

export default ProviderRow
